import React from 'react';
import SelectInput from '../SelectInput/SelectInput';
import ImageUploader from '../ImageUploader/ImageUploader';

const ToolInput = ({
  toolName, setToolName,
  genre, setGenre,
  brand, setBrand,
  color, setColor,
  images, setImages,
  description, setDescription,
  genreList, brandList, colorList,
  onSubmit,
  submitLabel = '追加',
}) => (
  <form onSubmit={onSubmit} style={{ flexDirection: 'column', alignItems: 'stretch', gap: 0, display: 'flex' }}>
    <label style={{ fontWeight: 'bold', marginBottom: 2 }}>道具名</label>
    <input
      type="text"
      value={toolName}
      onChange={e => setToolName(e.target.value)}
      placeholder="道具名を入力"
      style={{ marginBottom: 8, padding: 8, border: '1px solid #ccc', borderRadius: 4, fontSize: '1rem' }}
    />
    <SelectInput
      label="ジャンル"
      value={genre}
      onChange={e => setGenre(e.target.value)}
      options={genreList}
      placeholder="ジャンルを選択"
      className="input"
      style={{ marginTop: 4, marginBottom: 4 }}
      description="ジャンルは道具の種類（例：ニッパー、ヤスリ、ピンセットなど）を選択してください。"
    />
    <SelectInput
      label="ブランド"
      value={brand}
      onChange={e => setBrand(e.target.value)}
      options={brandList}
      placeholder="ブランドを選択"
      className="input"
      style={{ marginTop: 0, marginBottom: 8 }}
      description="ブランドはメーカー名（例：タミヤ、ゴッドハンドなど）を選択してください。"
    />
    <SelectInput
      label="色"
      value={color}
      onChange={e => setColor(e.target.value)}
      options={colorList}
      placeholder="色を選択"
      className="input"
      style={{ marginTop: 0, marginBottom: 8 }}
      description="色は道具の本体色や特徴的な色を選択してください。"
    />
    <label style={{ fontWeight: 'bold', marginBottom: 2 }}>画像</label>
    <ImageUploader images={images} setImages={setImages} max={3} label="画像" />
    <label style={{ fontWeight: 'bold', marginBottom: 2 }}>詳細</label>
    <textarea
      value={description}
      onChange={e => setDescription(e.target.value)}
      placeholder="道具の特徴やメモなど自由に記入"
      style={{ minHeight: 60, marginBottom: 8, resize: 'vertical', padding: 8, border: '1px solid #ccc', borderRadius: 4, fontSize: '1rem' }}
    />
    <button type="submit" style={{ background: '#1976d2', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 4, fontSize: '1rem', cursor: 'pointer', marginTop: 8 }}>{submitLabel}</button>
  </form>
);

export default ToolInput;
